export default {
  'successLinkPage.allSet': 'All set',
  'successLinkPage.sub.title': 'Sending you back to Grab app to earn more Stars',
  'successLinkPage.note': 'for orders via Grab delivery',
  //'successLinkPage.more.detail1': 'Check out more details and rewards on ',
  // 'successLinkPage.more.detail1':
  //   'Check out more details on Starbucks Singapore Mobile App hyperlink to ',
  'successLinkPage.more.detail1': 'Find out more about Starbucks® Rewards members’ benefits  ',
  //'successLinkPage.more.detail2': 'Starbucks Vietnam mobile app',
  // 'successLinkPage.more.detail2': 'Starbucks Singapore mobile app',
  'successLinkPage.more.detail2': 'here.',
  'successLinkPage.more.detail3': ' or ',
  // 'successLinkPage.sub.note1': 'Free drink for every 25 Stars (Gold exclusive)',
  'successLinkPage.sub.note1': 'Redeem Stars for free drink & food',
  'successLinkPage.sub.note2': 'Birthday treats on the house',
  'successLinkPage.sub.note3': 'Exclusive member offers',
};
